import { BrandLogo, DEFAULT_BRANDS } from '../../pages/product/product-types'

export const getBrandLogo = (brandName: string): BrandLogo | undefined => {
    const foundBrand = DEFAULT_BRANDS.find(brand => brand.name.toLowerCase() === brandName.toLowerCase())

    if (! foundBrand) {
        return undefined
    }

    return foundBrand
}
